export enum DialogGridActions {
  EditedBeforeCancel,
  NewAtParent,
  Saved,
  NotEdited,
}
